module.exports = __webpack_public_path__ + "static/media/logo-white.fd441063.png";